module.exports = {"notification.message":"Wix.com utilise les cookies afin de vous proposer une expérience optimale.","notification.got.it":"OK","notification.more.info":"En lire plus","notification.got.it.arrow":"arrow icon"}


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_fr.json
// module id = 47
// module chunks = 0